import React, { useState, useEffect } from 'react';
import './style.css';
import './element.css';
import './login_element.css';

import triangle from "./img/p3.svg"
import done from "./img/white/done-24px.svg"
import clear from "./img/white/clear-24px.svg"
import create from "./img/white/create-24px.svg"
import screenForPC from "./img/For_PC.png"
import applestore from "./img/applestore.svg"
import playstore from "./img/playstore.svg"

function App() {
  // const linkIos = "https://testflight.apple.com/join/HnSMzYC3"
  // const linkAndroid = "https://play.google.com/store/apps/details?id=com.test31"
  const linkIos = "https://apps.apple.com/ru/app/long-term-goals/id6443708558?platform=iphone"
  const linkAndroid = "https://drive.google.com/file/d/1neaO_2frs0bCICjZtasQKDWp1K6udmbq/view?usp=drive_link"

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight
  });

  const [regValues, setRegValues] = useState({
    login: "",
    // password: "",
    // confirmPassword: ""
  });


  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight
    })
  }

  useEffect(() => {
    window.addEventListener('resize', setDimension);

    getFromServer()

    return (() => {
      window.removeEventListener('resize', setDimension);
    })
  }, [screenSize])

  let renderYearElement2Mobile = () => {
    if (screenSize.dynamicWidth >= 540) {
      return (
        <div class="yearElement" id="yearElement-2-mobile">
          <img src={triangle} class="img-done" />
          <img src={create} class="img-create" />
          <img src={clear} class="img-clear" />
          My new long term goal
        </div>
      )
    } else {
      return (
        <div class="yearElement" id="yearElement-2-mobile">
          <img src={triangle} class="img-done" />
          My new long
        </div>
      )
    }
  }


  let render1 = () => {
    return (
      <div style={{ overflowX: "hidden" }}>
        <title id="header-for-info">Long Term Goals</title>
        <div id="info-mobile">
          <img src={screenForPC} class="screen-for-mobile" />
          <div>
            <a href={linkIos} class="store-link"><img src={applestore} class="store-icon" /><div>Apple Store</div></a>
            <a href={linkAndroid} class="store-link"><img src={playstore} class="store-icon" /><div>Play Market</div></a>
          </div>
        </div>
        <title>Long Term Goals</title>
        <div id="content-login-form">
          <div id="relative-elements-mobile">
            <div>
              <div class="yearElement" id="yearElement-1-mobile">
                <img src={done} class="img-done" />
                <img src={clear} class="img-clear" />
                This is some text for new
                element in text input
              </div>
              <div class="yearElement" id="yearElement-3-mobile">
                <img src={triangle} class="img-done" />
                Make new product
              </div>
            </div>
          </div>
          <div id="forms" class="mobile">
            <div id="login-label">Login</div>
            <form id="login" class="login-form" action="/" method="post">
              <label for="username">Login</label>
              <input id="login-username" type="text" name="username" autoComplete="off" />
              <div class="error-client"></div>
              <label for="password">Password</label>
              <input type="password" name="password" autoComplete="off" />
              <div class="error-client"></div>
              <button><span>Login</span></button>
              <div class="OAuth2-link-mobile">
                <a href="/oauth2/authorization/github">Login with Github</a>
                <a href='/apple'>Login with apple</a>
              </div>
            </form>
          </div>
        </div>
        <title>Long Term Goals</title>
        <div id="content-login-form">
          <div id="relative-elements-mobile">
            <div>
              <div class="yearElement" id="yearElement-2-mobile">
                <img src={triangle} class="img-done" />
                <img src={create} class="img-create" />
                <img src={clear} class="img-clear" />
                My new long term goal
              </div>
            </div>
          </div>
          <div id="forms" class="mobile">
            <div id="registration-label"><span>Registration</span><span style={{marginLeft: "30px"}}>or reset password</span></div>
            <form id="registration" class="login-form" action="/registration" method="post">
              <label for="username">Email</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = e.target.value
                  localRegValues.password = regValues.password
                  localRegValues.confirmPassword = regValues.confirmPassword
                  setRegValues(localRegValues);
                  clientErrorsCheckLogin()
                }}
                value={regValues.login}
                id="registration-username" type="text" name="username" autoComplete="off" />
              <div class="error-client" id="login-reg-error"></div>
              {/* <label for="password">Password</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = regValues.login
                  localRegValues.password = e.target.value
                  localRegValues.confirmPassword = regValues.confirmPassword
                  setRegValues(localRegValues);
                  clientErrorsCheckPassword()
                }}
                value={regValues.password}
                id="registration-password" type="password" name="password" autocomplete="off" />
              <div class="error-client" id="password-reg-error"></div>
              <label for="confirmed_password">Confirm Password</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = regValues.login
                  localRegValues.password = regValues.password
                  localRegValues.confirmPassword = e.target.value
                  setRegValues(localRegValues);
                  clientErrorsCheckPassword()
                }}
                value={regValues.confirmPassword}
                id="registration-confirmed-password" type="password" name="confirmed_password" autocomplete="off" />
              <div class="error-client" id="conf-password-reg-error"></div> */}
              <button><span>Reset password</span></button>
              <button><span>Registration</span></button>
            </form>
          </div>
        </div>
        {/* <title id="header-for-info">Long Term Goals</title>
        <div id="info-mobile">
          <img src={screenForMobile} class="screen-for-mobile" />
          <div>
            <a href='' class="store-link"><img src={applestore} class="store-icon" /><div>Apple Store</div></a>
            <a href='' class="store-link"><img src={playstore} class="store-icon" /><div>Play Market</div></a>
          </div>
        </div> */}
        <footer class="mobile" style={{ height: getFooterHeight1() }}>
        </footer>
      </div>
    );
  }

  const getFooterHeight1 = () => {
    let height = screenSize.dynamicHeight - 1250
    if (height < 100) {
      return "100px"
    } else {
      return height + "px"
    }
  }

  let render2 = () => {
    return (
      <div style={{ overflowX: "hidden" }}>
        <title>Long Term Goals</title>
        <div id="content-login-form">
          <div id="relative-elements">
            <div>
              <div class="yearElement" id="yearElement-1">
                <img src={done} class="img-done" />
                <img src={clear} class="img-clear" />
                This is some text for new
                element in text input
              </div>
              <div class="yearElement" id="yearElement-2">
                <img src={triangle} class="img-done" />
                <img src={create} class="img-create" />
                <img src={clear} class="img-clear" />
                My new long term goal
              </div>
              <div class="yearElement" id="yearElement-3">
                <img src={triangle} class="img-done" />
                Make new product
              </div>
              <div class="yearElement" id="yearElement-4">
                <img src={triangle} class="img-done" />
                Finish a difficult course
              </div>
            </div>
          </div>
          <div id="forms">
            <form id="login" class="login-form" action="/" method="post" >
              <label for="username">Login</label>
              <input id="login-username" type="text" name="username" autoComplete="off" />
              <div class="error-client"></div>
              <label for="password">Password</label>
              <input type="password" name="password" autoComplete="off" />
              <div class="error-client"></div>
              <button><span>Login</span></button>
              <div class="OAuth2-link">
                <a href="/oauth2/authorization/github">Login with Github</a>
                <a href='/apple'>Login with apple</a>
              </div>
            </form>
            <form id="registration" class="login-form" action="/registration" method="post" >
              <label for="username">Email</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = e.target.value
                  localRegValues.password = regValues.password
                  localRegValues.confirmPassword = regValues.confirmPassword
                  setRegValues(localRegValues);
                  clientErrorsCheckLogin()
                }}
                value={regValues.login}
                id="registration-username" type="text" name="username" autoComplete="off" />
              <div class="error-client" id="login-reg-error"></div>
              {/* <label for="password">Password</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = regValues.login
                  localRegValues.password = e.target.value
                  localRegValues.confirmPassword = regValues.confirmPassword
                  setRegValues(localRegValues);
                  clientErrorsCheckPassword()
                }}
                value={regValues.password}
                id="registration-password" type="password" name="password" autocomplete="off" />
              <div class="error-client" id="password-reg-error"></div>
              <label for="confirmed_password">Confirm Password</label>
              <input
                onChange={(e) => {
                  let localRegValues = {}
                  localRegValues.login = regValues.login
                  localRegValues.password = regValues.password
                  localRegValues.confirmPassword = e.target.value
                  setRegValues(localRegValues);
                  clientErrorsCheckPassword()
                }}
                value={regValues.confirmPassword}
                id="registration-confirmed-password" type="password" name="confirmed_password" autocomplete="off" />
              <div class="error-client" id="conf-password-reg-error"></div> */}
              <button><span>Reset password</span></button>
              <button><span>Registration</span></button>
            </form>
          </div>
        </div>
        <title id="header-for-info">Long Term Goals</title>
        <div id="content-info-PC">
          <div id="relative-elements">
            <div>
              <div class="yearElement" id="yearElement-1">
                <img src={done} class="img-done" />
                <img src={clear} class="img-clear" />
                This is some text for new
                element in text input
              </div>
              <div class="yearElement" id="yearElement-2">
                <img src={triangle} class="img-done" />
                <img src={create} class="img-create" />
                <img src={clear} class="img-clear" />
                My new long term goal
              </div>
              <div class="yearElement" id="yearElement-3">
                <img src={triangle} class="img-done" />
                Make new product
              </div>
              <div class="yearElement" id="yearElement-4">
                <img src={triangle} class="img-done" />
                Finish a difficult course
              </div>
            </div>
          </div>
          <div class="info-PC">
            <img src={screenForPC} class="screen-for-mobile" />
            <div>
              <a href={linkIos} class="store-link"><img src={applestore} class="store-icon" /><div>Apple Store</div></a>
              <a href={linkAndroid} class="store-link"><img src={playstore} class="store-icon" /><div>Play Market</div></a>
            </div>
          </div>
        </div>
        <footer style={{ height: getFooterHeight2() }}>
        </footer>
      </div>
    );
  }

  const getFooterHeight2 = () => {
    let height = screenSize.dynamicHeight - 628
    if (height < 144) {
      return "144px"
    } else {
      return height + "px"
    }
  }

  const getFromServer = () => {
    var params = window
      .location
      .search
      .replace('?', '')
      .split('&')
      .reduce(
        function (p, e) {
          var a = e.split('=');
          p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
          return p;
        },
        {}
      );

    console.log(params['username']);
    console.log(params['error']);
    if (params['username'] != undefined) {
      if (params['username'].trim() != '') {
        document.getElementById("registration-username").value = params['username']
        let localRegValues = {}
        localRegValues.login = params['username']
        setRegValues(localRegValues);
        clientErrorsCheckLogin()
      }
    }

    if (params['error'] != undefined) {
      if (params['error'].trim() != '') {
        console.log("document.getElementById('error-header')", document.getElementById("error-header"))
        if (document.getElementById("error-header") == null) {
          let div = document.createElement('div')
          div.id = "error-header"
          document.getElementById("content-login-form").prepend(div)
          document.getElementById("error-header").innerText = params['error']
        }
      }
    }

    if (params['mode'] != undefined) {
      if (params['mode'].trim() != '') {
        if (params['mode'] == 'only_auth') {
          let links = document.getElementsByClassName("store-link")
          for (let index = 0; index < links.length; index++) {
            links[index].removeAttribute("href");
            
          }
        }
      }
    }
  }

  const clientErrorsCheckLogin = () => {
    let regLogin = document.getElementById("login-reg-error")
    let regLoginInput = document.getElementById("registration-username")

    if (regLoginInput.value.indexOf("-") != -1) {
      regLogin.innerText = "Don’t use “-”sumbol"
    } else {
      regLogin.innerText = ""
    }
  }

  const clientErrorsCheckPassword = () => {
    let regPassword = document.getElementById("password-reg-error")
    let regConfirmPassword = document.getElementById("conf-password-reg-error")

    let regPasswordInput = document.getElementById("registration-password")
    let regConfirmPasswordInput = document.getElementById("registration-confirmed-password")

    if (regConfirmPasswordInput.value != regPasswordInput.value) {
      regConfirmPassword.innerText = "Password not equals"
    } else {
      regConfirmPassword.innerText = ""
    }

    if (regPasswordInput.value.length < 8) {
      regPassword.innerText = "Password min length 8 characters"
    } else {
      regPassword.innerText = ""
    }
  }

  if (screenSize.dynamicWidth < 1500) {
    return render1()
  } else {
    return render2()
  }
}

export default App;
